import React from 'react';
import { Box } from '@mui/material';
import BulkContent from './BulkContent';

export default function index() {
  return <BulkContent />;
}
